/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Sort_Library_Alphabetically_DescriptionInputs */

const en_mobile_sort_library_alphabetically_description = /** @type {(inputs: Mobile_Sort_Library_Alphabetically_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order files by title instead of newest first.`)
};

const es_mobile_sort_library_alphabetically_description = /** @type {(inputs: Mobile_Sort_Library_Alphabetically_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordena los archivos por título en vez de por más recientes.`)
};

/**
* | output |
* | --- |
* | "Order files by title instead of newest first." |
*
* @param {Mobile_Sort_Library_Alphabetically_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_sort_library_alphabetically_description = /** @type {((inputs?: Mobile_Sort_Library_Alphabetically_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Sort_Library_Alphabetically_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_sort_library_alphabetically_description(inputs)
	return en_mobile_sort_library_alphabetically_description(inputs)
});